import React from 'react'
import { Animated, TextStyle, View } from 'react-native'
import { color, SvgIcon, iconHowToVote, Text, Button } from '@trivie/ui-mobile'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from '@mui/material'
interface ConfirmationProps {
  title: string
}

export const Confirmation = (props: ConfirmationProps) => {
  const { title } = props

  const history = useHistory()
  const goToPlayScreen = () => history.goBack()

  const isMobile = !useMediaQuery('(min-width:800px)')

  const { t } = useTranslation()
  const thanks = t('Survey.thanks', {})

  return (
    <div style={FULL}>
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: 75,
        }}
      >
        <Text style={TITLE_STYLE} text={title} />
        <View
          style={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SvgIcon size={32} viewBox="0 0 32 32" color="#DADADA" src={iconHowToVote} />
          <Animated.Text
            allowFontScaling={false}
            style={{
              ...BODY_MESSAGE,
              color: color.white,
              paddingTop: 25,
            }}
          >
            {thanks}
          </Animated.Text>
        </View>
      </View>

      <View
        style={{
          flex: 2,
          justifyContent: 'flex-end',
        }}
      >
        <Button
          accessibilityRole="button"
          accessibilityLabel="Done, go to play screen"
          style={{
            minWidth: isMobile ? 320 : 400,
            alignSelf: 'center',
            marginHorizontal: 20,
            marginBottom: 40,
          }}
          tx="Common.done"
          onPress={() => goToPlayScreen()}
        />
      </View>
    </div>
  )
}

const FULL: React.CSSProperties = {
  backgroundColor: color.quizBackground,
  flex: 1,
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  flexDirection: 'column',
  zIndex: 998,
}

const TITLE_STYLE: TextStyle = {
  color: 'rgba(255, 255, 255, 0.5)',
  fontSize: 17,
  fontFamily: 'Inter',
  lineHeight: 22,
  fontWeight: '600',
  textAlign: 'center',
}

const BODY_MESSAGE: TextStyle = {
  color: color.white,
  fontSize: 24,
  fontFamily: 'Inter',
  lineHeight: 29,
  fontWeight: 'bold',
  textAlign: 'center',
}
